import { Avatar } from 'common/constant';
import DataTable from 'components/ui/DataTable/data-table';
import { backendURL } from 'redux/reducers/settings';
import { useTraineeDetailQuery } from 'redux/reducers/user';
import { PlaceType, TraineeProfile } from '../TraineeProfile';

type Props = {
  traineeId: string;
  attendance_pin: string;
};

const expCols = [
  {
    Header: 'Organization',
    accessor: 'organization'
  },
  { Header: 'Department', accessor: 'department' },
  { Header: 'Level', accessor: 'level' },
  { Header: 'From Date', accessor: 'from_date' },
  { Header: 'To Date', accessor: 'to_date' },
  {
    Header: 'Is it your first job ?',
    accessor: (row: TraineeProfile['experience'][0]) => (row.is_first_service ? 'True' : 'False')
  },
  {
    Header: 'Currently working here?',
    accessor: (row: TraineeProfile['experience'][0]) => (row.is_current_service ? 'True' : 'False')
  }
];

const traineeCols = [
  {
    Header: 'Name',
    accessor: 'name'
  },
  { Header: 'Place', accessor: 'place' },
  {
    Header: 'Type',
    accessor: (row: TraineeProfile['previous_training'][0]) => PlaceType[row.place_type]
  },
  { Header: 'From Date', accessor: 'from_date' },
  { Header: 'To Date', accessor: 'to_date' }
];

function TraineeView({ traineeId, attendance_pin }: Props) {
  const { data: traineeDetails } = useTraineeDetailQuery(
    { traineeId: traineeId },
    {
      skip: !traineeId
    }
  );

  const traineeDetail: any = traineeDetails;
  const {
    address,
    mobile_number,
    dob,
    email,
    first_name,
    middle_name,
    last_name,
    first_name_np,
    middle_name_np,
    last_name_np,
    experience,
    previous_training
  } = traineeDetail?.data || {};

  const fullName = `${first_name ?? ''} ${middle_name ?? ''} ${last_name ?? ''}`;
  const fullNameNp = `${first_name_np ?? ''} ${middle_name_np ?? ''} ${last_name_np ?? ''}`;

  return (
    <div className="row">
      <div className="col-xxl-4">
        <div className="col-auto d-flex align-items-center justify-content-around">
          <div className="avatar-lg">
            <img
              src={
                traineeDetail?.data?.image == ''
                  ? Avatar
                  : backendURL + '/' + traineeDetail?.data?.image
              }
              alt="user-img"
              className="img-thumbnail rounded-circle"
              style={{
                width: '92px',
                height: '92px',
                objectFit: 'cover'
              }}
            />
          </div>
          {/* 
          <div className="avatar-lg">
            <img
              src={traineeDetail?.signature ?? Avatar}
              alt="user-img"
              className="img-thumbnail rounded-circle"
              style={{
                width: '92px',
                height: '92px',
                objectFit: 'cover'
              }}
            />
          </div> */}
        </div>

        <div className="card">
          <div className="card-body p-4">
  <div className="d-flex align-items-center justify-content-between mb-4">
    <h5 className="card-title fw-bold text-primary mb-0">
      <i className="ri-information-line me-2"></i> General Information
    </h5>
    <span className="badge bg-light text-primary border px-3 py-2">
      PIN: {attendance_pin ?? ' - '}
    </span>
  </div>

  <div className="row g-4">
    {/* Full Name */}
    <div className="col-12 col-md-6">
      <label className="text-muted small fw-bold text-uppercase d-block mb-1">Full Name</label>
      <div className="fw-medium text-dark">
        {fullName ?? ' - '} 
        {fullNameNp?.trim() && <span className="text-muted ms-2 small">({fullNameNp})</span>}
      </div>
    </div>

    {/* Date of Birth */}
    <div className="col-12 col-md-6">
      <label className="text-muted small fw-bold text-uppercase d-block mb-1">Date of Birth</label>
      <div className="fw-medium text-dark">{dob ?? ' - '}</div>
    </div>

    {/* Contact Details */}
    <div className="col-12 col-md-6">
      <label className="text-muted small fw-bold text-uppercase d-block mb-1">Mobile Number</label>
      <div className="fw-medium text-dark text-nowrap">
        <span className="text-muted me-1">+977</span>{mobile_number ?? ' - '}
      </div>
    </div>

    <div className="col-12 col-md-6">
      <label className="text-muted small fw-bold text-uppercase d-block mb-1">E-mail Address</label>
      <div className="fw-medium text-dark text-break">{email ?? ' - '}</div>
    </div>

    {/* Location */}
    <div className="col-12">
      <label className="text-muted small fw-bold text-uppercase d-block mb-1">Location</label>
      <div className="fw-medium text-dark">
        {[
          address?.tole_street,
          address?.ward_no ? `Ward ${address.ward_no}` : null,
          address?.municipality,
          address?.province?.name_en
        ]
          .filter(Boolean)
          .join(', ') || ' - '}
      </div>
    </div>

    {/* Joining Date */}
    <div className="col-12 col-md-6">
      <label className="text-muted small fw-bold text-uppercase d-block mb-1">Joining Date</label>
      <div className="fw-medium text-dark">24 Nov 2021</div>
    </div>
  </div>
</div>
        </div>
      </div>

      <div className="col-xxl-8">
        <div className="card">
          <div className="card-body">
            <h5 className="card-title mb-3">Experience</h5>
            <DataTable data={experience ?? []} columns={expCols} />
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <h5 className="card-title mb-3">Training</h5>
            <DataTable data={previous_training ?? []} columns={traineeCols} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default TraineeView;
